const FALLBACK = { country: 'United Kingdom', countryCode: 'GB' };

export const getCountry = async () => {
  // Return cached value if already set
  if (localStorage.getItem('country_code')) return {
    country:     localStorage.getItem('country'),
    countryCode: localStorage.getItem('country_code'),
  };

  try {
    const res  = await fetch('http://ip-api.com/json/?fields=country,countryCode');
    const data = await res.json();

    if (data.countryCode) {
      localStorage.setItem('country',      data.country);
      localStorage.setItem('country_code', data.countryCode);
      return data;
    }
    // ip-api responded but couldn't geolocate (e.g. private/localhost IP)
    // — fall through to the default below
  } catch (_) {
    // Network error — fall through to default
  }

  localStorage.setItem('country',      FALLBACK.country);
  localStorage.setItem('country_code', FALLBACK.countryCode);
  return FALLBACK;
};